export enum FolderBusinessEntityType {
  BusinessEvent = 'BusinessEvent',
  Collaboration = 'Collaboration',
  Folder = 'Folder',
  Mission = 'Mission',
}
